import { render } from "./mediumdetails.vue?vue&type=template&id=b09614f0"
import script from "./mediumdetails.vue?vue&type=script&lang=js"
export * from "./mediumdetails.vue?vue&type=script&lang=js"

import "./mediumdetails.vue?vue&type=style&index=0&id=b09614f0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__